/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EstimationGroupMeteringPointSearchQuery } from '../model/estimationGroupMeteringPointSearchQuery';
// @ts-ignore
import { EstimationGroupSearchQuery } from '../model/estimationGroupSearchQuery';
// @ts-ignore
import { PagedResultOfEstimationGroupMeteringPointSearchResult } from '../model/pagedResultOfEstimationGroupMeteringPointSearchResult';
// @ts-ignore
import { PagedResultOfEstimationGroupSearchResult } from '../model/pagedResultOfEstimationGroupSearchResult';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class EstimationGroupsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /vee/EstimationGroups/meteringpoints/search
     * @param estimationGroupMeteringPointSearchQuery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public veeEstimationGroupsMeteringpointsSearchPost(estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedResultOfEstimationGroupMeteringPointSearchResult>;
    public veeEstimationGroupsMeteringpointsSearchPost(estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedResultOfEstimationGroupMeteringPointSearchResult>>;
    public veeEstimationGroupsMeteringpointsSearchPost(estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedResultOfEstimationGroupMeteringPointSearchResult>>;
    public veeEstimationGroupsMeteringpointsSearchPost(estimationGroupMeteringPointSearchQuery: EstimationGroupMeteringPointSearchQuery, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (estimationGroupMeteringPointSearchQuery === null || estimationGroupMeteringPointSearchQuery === undefined) {
            throw new Error('Required parameter estimationGroupMeteringPointSearchQuery was null or undefined when calling veeEstimationGroupsMeteringpointsSearchPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vee/EstimationGroups/meteringpoints/search`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedResultOfEstimationGroupMeteringPointSearchResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: estimationGroupMeteringPointSearchQuery,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /vee/EstimationGroups/search
     * @param estimationGroupSearchQuery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public veeEstimationGroupsSearchPost(estimationGroupSearchQuery: EstimationGroupSearchQuery, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedResultOfEstimationGroupSearchResult>;
    public veeEstimationGroupsSearchPost(estimationGroupSearchQuery: EstimationGroupSearchQuery, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedResultOfEstimationGroupSearchResult>>;
    public veeEstimationGroupsSearchPost(estimationGroupSearchQuery: EstimationGroupSearchQuery, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedResultOfEstimationGroupSearchResult>>;
    public veeEstimationGroupsSearchPost(estimationGroupSearchQuery: EstimationGroupSearchQuery, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (estimationGroupSearchQuery === null || estimationGroupSearchQuery === undefined) {
            throw new Error('Required parameter estimationGroupSearchQuery was null or undefined when calling veeEstimationGroupsSearchPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vee/EstimationGroups/search`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedResultOfEstimationGroupSearchResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: estimationGroupSearchQuery,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
